// extracted by mini-css-extract-plugin
export default {"component":"HeroContent__component-iGfm","title":"HeroContent__title-qKdq","subTitle":"HeroContent__subTitle-Ljby"};